import { Icon, NavigationIcon } from '@cbhq/cds-web/icons';
import { Fallback, HStack, VStack } from '@cbhq/cds-web/layout';
import { TextBody, TextHeadline } from '@cbhq/cds-web/typography';

import useSubscriptionState, { isFreeTrial } from ':cloud/hooks/useSubscriptionState';
import { BillingMeter } from ':cloud/types/ts_types';
import { currencyFormatter } from ':cloud/utils/formatters/currency';

import { FieldCopy } from './FieldCopy';

interface PricingInformationProps {
  meter?: BillingMeter;
  unitType: string;
}
function PricingInformation({ meter, unitType }: PricingInformationProps) {
  if (!meter) {
    return <Fallback height="1rem" width={200} />;
  }
  return (
    <TextBody as="p" color="foregroundMuted">
      Starting at {currencyFormatter(Number(meter?.pricePerUnit))} per {unitType}/month
    </TextBody>
  );
}

interface FreeTrialInformationProps {
  content?: string;
}
function FreeTrialInformation({ content }: FreeTrialInformationProps) {
  if (!content) {
    return <Fallback height="1rem" width={200} />;
  }
  return (
    <TextBody as="p" color="foregroundMuted">
      {content}
    </TextBody>
  );
}

interface ConnectedProductsFieldProps {
  meter?: BillingMeter;
  unitType: string;
}
export function ConnectedProductsField({ meter, unitType }: ConnectedProductsFieldProps) {
  const { status, shortMessageText } = useSubscriptionState();
  return (
    <>
      <FieldCopy
        title="Connected products"
        description="Select the product you&rsquo;d like to add to your project. You can add more later."
      />
      <HStack
        spacingStart={3}
        spacingEnd={7}
        spacingVertical={1}
        justifyContent="space-between"
        alignItems="center"
        borderRadius="rounded"
        background="backgroundAlternate"
        gap={2}
      >
        <HStack gap={3} alignItems="center">
          <NavigationIcon name="waasProduct" size="l" />
          <VStack>
            <TextHeadline as="p">Wallet as a Service</TextHeadline>
            {isFreeTrial(status) ? (
              <FreeTrialInformation content={shortMessageText} />
            ) : (
              <PricingInformation meter={meter} unitType={unitType} />
            )}
          </VStack>
        </HStack>
        <Icon name="checkmark" size="m" />
      </HStack>
    </>
  );
}
